function initVideoReviews() {
    const sliderWrapper = document.querySelectorAll('.video-reviews__wrapper');
    sliderWrapper.forEach(wrapper => {
        if (!wrapper) return;

        const id = wrapper.dataset.sectionId;
        const container = wrapper.querySelector('#video-reviews-' + id);
        const nextElement = wrapper.querySelector('.swiper-button-next');
        const prevElement = wrapper.querySelector('.swiper-button-prev');
        const scrollBar = wrapper.querySelector('.swiper-scrollbar');

        if (!container) return;

        function pauseAllVideos() {
            const videos = wrapper.querySelectorAll('.video-reviews__video');

            videos.forEach(video => {
                video.pause();

                const videoWrapper = video.closest('.video-reviews__video-wrapper');
                const playBtn = videoWrapper.querySelector('.video-reviews__video-icon-play');
                const pauseBtn = videoWrapper.querySelector('.video-reviews__video-icon-pause');

                if (playBtn && pauseBtn) {
                    playBtn.style.display = "block";
                    pauseBtn.style.display = "none";
                }
            });
        }

        if (container.swiper) {
            container.swiper.destroy();
        }

        let swiper = new Swiper(container, {
            effect: "slide",
            slidesPerView: 1.1,
            spaceBetween: 16,
            navigation: {
                nextEl: nextElement,
                prevEl: prevElement,
            },
            scrollbar: {
                el: scrollBar,
                hide: true,
            },
            breakpoints: {
                700: { slidesPerView: 2.2 },
                1000: { slidesPerView: 3.2 },
                1600: { slidesPerView: 4.2 },
            },
            on: {
                slideChange: () => {
                    pauseAllVideos();
                },
            },
        });

        const videos = wrapper.querySelectorAll('.video-reviews__video');
        videos.forEach(video => {
            video.addEventListener('ended', () => {
                const videoWrapper = video.closest('.video-reviews__video-wrapper');
                const playBtn = videoWrapper.querySelector('.video-reviews__video-icon-play');
                const pauseBtn = videoWrapper.querySelector('.video-reviews__video-icon-pause');

                if (playBtn && pauseBtn) {
                    playBtn.style.display = "block";
                    pauseBtn.style.display = "none";
                }
            });
        });

    });
}
function videoReviews() {
    const playBtn = document.querySelectorAll(".video-reviews__video-icon-play");
    const pauseBtn = document.querySelectorAll(".video-reviews__video-icon-pause");

    playBtn.forEach(btn => {
        btn.addEventListener('click', () => {
            const wrapper = btn.closest('.video-reviews__video-wrapper');
            const video = wrapper.querySelector('.video-reviews__video');
            const pauseButton = wrapper.querySelector('.video-reviews__video-icon-pause');

            if (video) {
                video.play();

                document.querySelectorAll('.video-reviews__video').forEach(v => {
                    if (v !== video) v.pause();
                });

                document.querySelectorAll('.video-reviews__video-icon-play').forEach(p => p.style.display = "block");
                document.querySelectorAll('.video-reviews__video-icon-pause').forEach(p => p.style.display = "none");

                btn.style.display = "none";
                pauseButton.style.display = "block";
            }
        });
    });

    pauseBtn.forEach(btn => {
        btn.addEventListener('click', () => {
            const wrapper = btn.closest('.video-reviews__video-wrapper');
            const video = wrapper.querySelector('.video-reviews__video');
            const playButton = wrapper.querySelector('.video-reviews__video-icon-play');

            if (video) {
                video.pause();

                btn.style.display = "none";
                playButton.style.display = "block";
            }
        });
    });
}

document.addEventListener("DOMContentLoaded", function () {
    initVideoReviews();
    videoReviews();
});